module.exports = __webpack_public_path__ + "img/wgmi-vert.3d215cd8.png";